import {
  DefenseAlarmGradeTypes,
  DefenseAlarmStatusTypes,
  DefenseChannelTypes,
  DefenseEventTypes,
  DefenseUnityTypes,
  IDefenseEventNotifyAlarmProps,
} from '../../../../services/Defense/Events/types';
import { Grid2 } from '@mui/material';
import TextFieldComponent from '../../../../components/TextFieldComponent';
import React from 'react';
import TableComponent, {
  IColumnProps,
} from '../../../../components/TableComponent';
import {
  convertAlarmGrade,
  convertAlarmStatus,
  convertChannelType,
  convertEventType,
  convertUnityType,
} from '../../../../converters/Defense/ConverterDefense';
import dayjs from 'dayjs';
import DateFieldComponent from '../../../../components/DateFieldComponent';

interface IDefenseNotifyAlarmContentProps {
  event: IDefenseEventNotifyAlarmProps;
}

const DefenseNotifyAlarmContent = ({
  event,
}: IDefenseNotifyAlarmContentProps) => {
  const formatCreatedAt = (date: Date) => {
    return dayjs(date, 'YYYY/MM/DD HH:mm:ss');
  };

  const formatDefenseDate = (date: Date) => {
    return dayjs(date);
  };

  const columns: IColumnProps[] = [
    {
      id: 'id',
      label: 'ID',
      width: 'auto',
    },
    {
      id: 'channelId',
      label: 'ID do Canal',
      width: 'auto',
    },
    {
      id: 'channelName',
      label: 'Nome do Canal',
      width: 'auto',
    },
    {
      id: 'streamId',
      label: 'ID da Stream',
      width: 'auto',
    },
    {
      id: 'streamType',
      label: 'Tipo da Stream',
      width: 'auto',
    },
  ];

  return (
    <Grid2
      container
      direction={{ xs: 'column', lg: 'row' }}
      size={12}
      spacing={{ xs: 0, lg: 3 }}
      justifyContent={'center'}
      alignItems={{ xs: 'center', lg: 'normal' }}
    >
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <TextFieldComponent
          label="Dispositivo"
          value={event?.device?.name ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Tipo"
          value={
            convertEventType(event.type as DefenseEventTypes) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <DateFieldComponent
          label="Data/Hora"
          value={formatCreatedAt(event.createdAt)}
          readOnly={true}
        />

        <TextFieldComponent
          label="Código de Alarme"
          value={event?.alarmCode.toUpperCase() ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <DateFieldComponent
          label="Data/Hora Alarme"
          value={formatDefenseDate(event.alarmDate)}
          readOnly={true}
        />
        <TextFieldComponent
          label="Fonte do Alarme"
          value={event?.alarmSourceName ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Grau de Urgência"
          value={
            convertAlarmGrade(
              event.alarmGradeTypes as DefenseAlarmGradeTypes,
            ) ?? 'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 6 }}>
        <TextFieldComponent
          label="Status de Alarme"
          value={
            convertAlarmStatus(event.alarmStatus as DefenseAlarmStatusTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="ID do Canal"
          value={event?.channelId ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Número do Canal"
          value={event?.channelNumber ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Tipo do Canal"
          value={
            convertChannelType(event.channelType as DefenseChannelTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Tipo da Unidade"
          value={
            convertUnityType(event.unitType as DefenseUnityTypes) ??
            'Não Possui'
          }
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
        <TextFieldComponent
          label="Descrição"
          value={event.description ?? 'Não Possui'}
          type={'text'}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          multiline
        />
      </Grid2>
      {event.videoChannels && event.videoChannels.length != 0 && (
        <TableComponent
          title={'Canais de Vídeo'}
          rows={event.videoChannels}
          columns={columns}
        />
      )}
    </Grid2>
  );
};

export default DefenseNotifyAlarmContent;
